'use strict';
/* globals $, alert, confirm */
/**
 * @ngdoc function
 * @name formDesignerApp.controller:fdEditOverlayCtrl
 * @description
 * # fdEditOverlayCtrl
 * Controller of the edit overlay
 */

import {
  isValidExpression,
  unterscheidungszeichenIsValid,
  valuesExpressionMatchesPattern
} from '../services/validations';

const layoutFormFields = ['CHECKBOX', 'RADIO_BUTTONS', 'BOOLEAN'];

angular.module('formApp').controller('fdEditOverlayCtrl', [
  '$scope',
  '$timeout',
  'mappings',
  'resizeGuard',
  'elementHelper',
  'validationHelper',
  'formHelper',
  'tableHelper',
  'constants',
  function (
    $scope,
    $timeout,
    mappings,
    resizeGuard,
    elementHelper,
    validationHelper,
    formHelper,
    tableHelper,
    constants
  ) {
    $scope.init = function () {
      $scope.helpers = {
        element: elementHelper,
        validation: validationHelper,
        form: formHelper,
        table: tableHelper,
        constants: constants
      };
      $scope.mappings = angular.copy(mappings);
      $scope.models.newPossibleValue = {};
      $scope.models.editing = false;
      $scope.models.editedPossibleValue = null;
      $scope.models.elementCopy = angular.copy($scope.models.element);
      $scope.allowedValidationRules = elementHelper.getAllowedValidationRules($scope.models.elementCopy);

      if (
        $scope.models.elementCopy.externalDataSourceProperties &&
        !$scope.models.elementCopy.externalDataSourceProperties.headers
      ) {
        $scope.models.elementCopy.externalDataSourceProperties.headers = {};
      }

      if ($scope.models.elementCopy.rows && !$scope.models.elementCopy.layout) {
        if ($scope.models.elementCopy.multiple) {
          $scope.models.elementCopy.layout = 'MULTIPLE';
        } else {
          $scope.models.elementCopy.layout = 'SINGLE';
        }
      }

      if (
        $scope.models.elementCopy.type === 'STRING_AJAX_AUTOCOMPLETE' &&
        $scope.models.elementCopy.additionalConfig === undefined
      ) {
        $scope.models.elementCopy.additionalConfig = { type: 'AdditionalStringAjaxAutocompleteConfig' };
      }

      if (
        $scope.models.elementCopy.type === 'STRING_AJAX_AUTOCOMPLETE' &&
        $scope.models.elementCopy.additionalConfig.autocompleteMinCharCount === undefined
      ) {
        $scope.models.elementCopy.additionalConfig.autocompleteMinCharCount = '3';
      }

      if (
        $scope.models.elementCopy.type === 'STRING_AJAX_AUTOCOMPLETE' &&
        typeof $scope.models.elementCopy.additionalConfig.autocompleteMinCharCount === 'number'
      ) {
        $scope.models.elementCopy.additionalConfig.autocompleteMinCharCount =
          $scope.models.elementCopy.additionalConfig.autocompleteMinCharCount.toString();
      }

      if (!$scope.models.elementCopy.fixedFieldGroupInstanceCount && $scope.models.elementCopy.maxInstanceCount) {
        $scope.models.elementCopy.fixedFieldGroupInstanceMax = true;
      }

      if (
        $scope.models.elementCopy.type === 'STRING' &&
        $scope.models.elementCopy.additionalConfig &&
        $scope.models.elementCopy.additionalConfig['@type'] === 'AdditionalMonthYearFormatConfig'
      ) {
        $scope.models.format = 'MONTH_YEAR';
      } else if (
        $scope.models.elementCopy.type === 'STRING' &&
        $scope.models.elementCopy.validationRules &&
        $scope.models.elementCopy.validationRules.some((rule) => {
          return rule['@type'] && rule['@type'] === 'IBANValidator';
        })
      ) {
        $scope.models.format = 'IBAN';
      } else {
        delete $scope.models.format;
      }

      // KFZ Kennzeichen
      if ($scope.models.elementCopy.type === 'KFZ_KENNZEICHEN') {
        // Kennzeichentyp
        $scope.models.kennzeichenType = $scope.models.elementCopy.additionalConfig.kennzeichenType || 'CAR';

        // elektrisch
        if ($scope.models.elementCopy.additionalConfig.electric) {
          $scope.models.electric = 'on';
        } else if ($scope.models.elementCopy.additionalConfig.electricExpression) {
          $scope.models.electric = 'showExpression';
        } else {
          $scope.models.electric = 'off';
        }
        // historisch
        if ($scope.models.elementCopy.additionalConfig.historic) {
          $scope.models.historic = 'on';
        } else if ($scope.models.elementCopy.additionalConfig.historicExpression) {
          $scope.models.historic = 'showExpression';
        } else {
          $scope.models.historic = 'off';
        }
        // erkennungsnummer2 ausblenden
        if ($scope.models.elementCopy.additionalConfig.erkennungsnummer2Ausblenden) {
          $scope.models.erkennungsnummer2Ausblenden = 'on';
        } else if ($scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression) {
          $scope.models.erkennungsnummer2Ausblenden = 'showExpression';
        } else {
          $scope.models.erkennungsnummer2Ausblenden = 'off';
        }
      }

      $scope.tinymceOptions = {
        entity_encoding: 'raw',
        language: 'de',
        language_url: 'scripts/lib/tinymce/langs/de.js', // jshint ignore:line
        convert_fonts_to_spans: true, // jshint ignore:line
        inline: false,
        menubar: false,
        statusbar: false,
        skin: 'lightgray',
        skin_url: 'scripts/lib/tinymce/skins/lightgray', // jshint ignore:line
        theme: 'modern',
        theme_url: 'scripts/lib/tinymce/themes/modern/theme.js', // jshint ignore:line
        toolbar: 'undo redo | bold | bullist',
        valid_elements: 'ul,li,strong/b,p,br', // jshint ignore:line
        plugins: '',
        style_formats: [
          {
            // jshint ignore:line
            title: 'Headers',
            items: [
              {
                title: 'Header 3',
                format: 'h3'
              },
              {
                title: 'Header 4',
                format: 'h4'
              },
              {
                title: 'Header 5',
                format: 'h5'
              },
              {
                title: 'Header 6',
                format: 'h6'
              }
            ]
          },
          {
            title: 'Inline',
            items: [
              {
                title: 'Bold',
                icon: 'bold',
                format: 'bold'
              },
              {
                title: 'Italic',
                icon: 'italic',
                format: 'italic'
              },
              {
                title: 'Underline',
                icon: 'underline',
                format: 'underline'
              },
              {
                title: 'Strikethrough',
                icon: 'strikethrough',
                format: 'strikethrough'
              },
              {
                title: 'Superscript',
                icon: 'superscript',
                format: 'superscript'
              },
              {
                title: 'Subscript',
                icon: 'subscript',
                format: 'subscript'
              },
              {
                title: 'Code',
                icon: 'code',
                format: 'code'
              }
            ]
          },
          {
            title: 'Blocks',
            items: [
              {
                title: 'Paragraph',
                format: 'p'
              },
              {
                title: 'Blockquote',
                format: 'blockquote'
              },
              {
                title: 'Div',
                format: 'div'
              },
              {
                title: 'Pre',
                format: 'pre'
              }
            ]
          },
          {
            title: 'Alignment',
            items: [
              {
                title: 'Left',
                icon: 'alignleft',
                format: 'alignleft'
              },
              {
                title: 'Center',
                icon: 'aligncenter',
                format: 'aligncenter'
              },
              {
                title: 'Right',
                icon: 'alignright',
                format: 'alignright'
              },
              {
                title: 'Justify',
                icon: 'alignjustify',
                format: 'alignjustify'
              }
            ]
          }
        ]
      };

      $scope.models.possibleInstanceValues = [
        {
          value: -1,
          label: 'Selbe Instanz'
        },
        {
          value: 0,
          label: 'Erste Instanz'
        },
        {
          value: 1,
          label: 'Zweite Instanz'
        },
        {
          value: 2,
          label: 'Dritte Instanz'
        },
        {
          value: 3,
          label: 'Vierte Instanz'
        },
        {
          value: 4,
          label: 'Fünfte Instanz'
        },
        {
          value: 5,
          label: 'Sechste Instanz'
        },
        {
          value: 6,
          label: 'Siebte Instanz'
        },
        {
          value: 7,
          label: 'Achte Instanz'
        },
        {
          value: 8,
          label: 'Neunte Instanz'
        },
        {
          value: 9,
          label: 'Zehnte Instanz'
        },
        {
          value: -2,
          label: 'Alle Instanzen'
        }
      ];

      $scope.models.possibleLayoutValues = [
        {
          label: 'Wert zurücksetzen',
          value: ''
        },
        {
          label: 'horizontale Liste',
          value: 'horizontal'
        },
        {
          label: 'vertikale Liste',
          value: 'vertical'
        }
      ];

      $scope.models.listSource = [
        {
          label: 'Formular',
          value: 'form'
        },
        {
          label: 'Prozess',
          value: 'process'
        },
        {
          label: 'Service',
          value: 'service'
        }
      ];

      $scope.models.possibleDataSourceScopes = {
        EMPTY: 'Keine Daten',
        CURRENT_FIELD: 'Wert des aktuellen Feldes',
        CURRENT_INSTANCE: 'Alle Werte aller Felder der aktuellen Feldgruppeninstanz',
        DEFINED: 'Werte definierter Formularfelder'
      };

      $scope.models.possibleExternalValidationScopes = {
        CURRENT_FIELD: 'Wert des aktuellen Feldes',
        CURRENT_INSTANCE: 'Alle Werte aller Felder der aktuellen Feldgruppeninstanz',
        DEFINED: 'Werte definierter Formularfelder'
      };

      $scope.models.possibleFieldGroupLayouts = {
        SINGLE: 'Feldgruppe',
        MULTIPLE: 'Feldgruppen (Mehrfach ausfüllbar)',
        ACCORDION: 'Akkordeon (Mehrfach ausfüllbar)'
      };

      $scope.models.possiblePrintOptions = {
        FORM: 'Nur in Formularansicht',
        PDF: 'Nur in Druckansicht'
      };

      if ($scope.models.engineVersion === '2') {
        $scope.models.pickerDisabled =
          !!$scope.models.elementCopy.additionalConfig && !!$scope.models.elementCopy.additionalConfig.pickerDisabled;
        $scope.models.filterable =
          !!$scope.models.elementCopy.additionalConfig && !!$scope.models.elementCopy.additionalConfig.filterable;

        if (layoutFormFields.includes($scope.models.elementCopy.type) && $scope.models.elementCopy.additionalConfig) {
          $scope.models.elementCopy.layout = $scope.models.elementCopy.additionalConfig.layout;
        }
      } else {
        $scope.models.pickerDisabled = !!$scope.models.elementCopy.pickerDisabled;
        $scope.models.filterable = !!$scope.models.elementCopy.filterable;
      }

      if ($scope.models.elementCopy.width && typeof $scope.models.elementCopy.width === 'string') {
        $scope.models.elementCopy.width = parseInt($scope.models.elementCopy.width, 10);
      }

      if ($scope.models.elementCopy.possibleValuesSource) {
        if ($scope.models.elementCopy.possibleValuesSource.service === 'prozess') {
          $scope.models.selectedListSource = 'process';
          $scope.models.selectedListVariable = $scope.models.elementCopy.possibleValuesSource.variableName;
        } else {
          $scope.models.selectedListSource = 'service';
          $scope.models.selectedListUrl = $scope.models.elementCopy.possibleValuesSource.service;
          $scope.models.selectedListVariable = $scope.models.elementCopy.possibleValuesSource.variableName;
        }
      } else {
        $scope.models.selectedListSource = 'form';
      }

      $scope.models.elementCopy.$$binding = {};
      if ($scope.models.elementCopy.source) {
        $scope.models.elementCopy.$$binding.inbound = {};
        if ($scope.models.elementCopy.source.service === 'prozess') {
          $scope.models.elementCopy.$$binding.inbound.type = 'process';
        } else if ($scope.models.elementCopy.source.service === 'servicekonto') {
          $scope.models.elementCopy.$$binding.inbound.type = 'servicekonto';
        } else if ($scope.models.elementCopy.source.service === 'npa') {
          $scope.models.elementCopy.$$binding.inbound.type = 'npa';
        } else if ($scope.models.elementCopy.source.service === 'vn_basis') {
          $scope.models.elementCopy.$$binding.inbound.type = 'vn_basis';
        } else if ($scope.models.elementCopy.source.service === 'vn_substanziell') {
          $scope.models.elementCopy.$$binding.inbound.type = 'vn_substanziell';
        } else if ($scope.models.elementCopy.source.service === 'vn_hoch') {
          $scope.models.elementCopy.$$binding.inbound.type = 'vn_hoch';
        } else if ($scope.models.elementCopy.source.service === 'browser_autocomplete') {
          $scope.models.elementCopy.$$binding.inbound.type = 'browser_autocomplete';
        } else {
          $scope.models.elementCopy.$$binding.inbound.type = 'service';
          $scope.models.elementCopy.$$binding.inbound.url = $scope.models.elementCopy.source.service;
        }
        $scope.models.elementCopy.$$binding.inbound.variable = $scope.models.elementCopy.source.variableName;
      }

      if ($scope.models.elementCopy.target) {
        $scope.models.elementCopy.$$binding.outbound = {};
        if ($scope.models.elementCopy.target.service === 'prozess') {
          $scope.models.elementCopy.$$binding.outbound.type = 'process';
        } else {
          $scope.models.elementCopy.$$binding.outbound.type = 'service';
          $scope.models.elementCopy.$$binding.outbound.url = $scope.models.elementCopy.target.service;
        }
        $scope.models.elementCopy.$$binding.outbound.variable = $scope.models.elementCopy.target.variableName;
      }

      if ($scope.models.elementCopy.rows) {
        $scope.models.elementChildren = [];
        angular.forEach($scope.models.elementCopy.rows, function (row) {
          $scope.models.elementChildren = $scope.models.elementChildren.concat(row.fields);
        });
      }

      if ($scope.models.elementCopy.helpDialog && $scope.models.elementCopy.helpDialog.url) {
        $scope.models.displayHelpDialog = true;
      }

      $scope.seconds2Date();

      // TODO: Solve this with Angular
      $('body').addClass('fd-s-unscrollable');

      resizeGuard.registerGuardian($scope.tabPaneResizeGuardian);
      $scope.tabPaneResizeGuardian();
    };

    $scope.editPossibleValue = function (value) {
      $scope.models.editing = true;
      $scope.models.editedPossibleValue = value;
      $scope.models.newPossibleValue = angular.copy(value);
      if (!$scope.models.newPossibleValue.helpDialog) {
        $scope.models.newPossibleValue.helpDialog = {};
      } else {
        $scope.models.newPossibleValue.displayHelpDialog = true;
      }
    };

    $scope.isHelpDialogForPossibleValueAllowed = function () {
      return $scope.models.elementCopy.type === 'RADIO_BUTTONS' || $scope.models.elementCopy.type === 'CHECKBOX';
    };

    $scope.addOrEditPossibleValue = function (helpDialogForm) {
      var valueIndex;

      if (helpDialogForm && !helpDialogForm.$valid) {
        alert('Die zusätzliche Hilfestellung wurde nicht korrekt ausgefüllt.');
        return;
      }

      if ($scope.models.editing) {
        $scope.models.editing = false;
        if (elementHelper.getValueType($scope.models.elementCopy) === 'single') {
          if ($scope.models.elementCopy.value === $scope.models.editedPossibleValue.value) {
            $scope.models.elementCopy.value = $scope.models.newPossibleValue.value;
          }
        } else {
          valueIndex = $scope.models.elementCopy.value.indexOf($scope.models.editedPossibleValue.value);
          if (valueIndex !== -1) {
            $scope.models.elementCopy.value.splice(valueIndex, 1, $scope.models.newPossibleValue.value);
          }
        }
        $scope.models.editedPossibleValue.value = $scope.models.newPossibleValue.value;
        $scope.models.editedPossibleValue.label = $scope.models.newPossibleValue.label;
        $scope.models.editedPossibleValue.helpDialog = $scope.models.newPossibleValue.helpDialog;
        if (!$scope.models.newPossibleValue.displayHelpDialog) {
          delete $scope.models.editedPossibleValue.helpDialog;
        }
        $scope.models.editedPossibleValue = null;
      } else {
        elementHelper.addPossibleValue($scope.models.elementCopy, $scope.models.newPossibleValue);
      }
      $scope.models.newPossibleValue = {
        helpDialog: {}
      };
    };

    $scope.onfixedFieldGroupInstanceCountChange = function () {
      if (!$scope.models.elementCopy.fixedFieldGroupInstanceCount) {
        delete $scope.models.elementCopy.fixedFieldGroupInstanceCount;
      } else {
        delete $scope.models.elementCopy.fixedFieldGroupInstanceMax;
      }
    };

    $scope.onFieldGroupInstanceMaxChange = function () {
      if (!$scope.models.elementCopy.fixedFieldGroupInstanceMax) {
        delete $scope.models.elementCopy.fixedFieldGroupInstanceMax;
        delete $scope.models.elementCopy.maxInstanceCount;
        delete $scope.models.elementCopy.addRowButtonInfoText;
      }
    };

    let groupContainsIllegalField = (group) => {
      for (const row of group.rows) {
        let rowContainsVideoFields = row.fields.some((field) => {
          const mapping = mappings.elements[field.type.toLowerCase()];
          if (mapping.disallowInMultipleFieldGroups) {
            $scope.illegalFieldType = mapping.label;
            return true;
          }
        });
        if (rowContainsVideoFields) {
          return true;
        }
      }
      return false;
    };

    $scope.anyChildElementHasRenderOnlyInAttribute = function () {
      if ($scope.models.containingFieldGroup !== undefined) {
        return false;
      }
      return $scope.models.elementChildren
        .map((element) => elementSetsRenderOnlyInAttribute(element))
        .find((value) => value);
    };

    $scope.parentHasRenderOnlyInAttribute = function () {
      if ($scope.models.containingFieldGroup === undefined) {
        return false;
      }

      return elementSetsRenderOnlyInAttribute($scope.models.containingFieldGroup);
    };

    const elementSetsRenderOnlyInAttribute = function (element) {
      return element.printOnly || ['FORM', 'PDF'].includes(element.renderOnlyIn);
    };

    $scope.hasRenderOptions = function () {
      return [
        'string',
        'textarea',
        'boolean',
        'text',
        'checkbox',
        'single_checkbox',
        'dropdown_single_select',
        'dropdown_multiple_select',
        'radio_buttons',
        'time',
        'date',
        'euro_betrag',
        'string_ajax_autocomplete',
        'dropdown_single_select_ajax'
      ].includes($scope.models.elementCopy.type.toLowerCase());
    };

    $scope.onRenderOnlyInChanged = function () {
      delete $scope.models.elementCopy.printOnly;
    };

    $scope.onLayoutChange = function () {
      switch ($scope.models.elementCopy.layout) {
        case 'SINGLE':
          delete $scope.models.elementCopy.instanceTitleTemplate;
          delete $scope.models.elementCopy.multiple;
          delete $scope.models.elementCopy.fixedFieldGroupInstanceCount;
          delete $scope.models.elementCopy.fixedFieldGroupInstanceMax;
          delete $scope.models.elementCopy.maxInstanceCount;
          delete $scope.models.elementCopy.addRowButtonInfoText;
          delete $scope.models.elementCopy.deleteRowButtonInfoText;
          $scope.fieldGroupContainsIllegalFields = false;
          break;
        case 'MULTIPLE':
          delete $scope.models.elementCopy.instanceTitleTemplate;
          $scope.models.elementCopy.multiple = true;
          if (groupContainsIllegalField($scope.models.elementCopy)) {
            $scope.fieldGroupContainsIllegalFields = true;
          }
          break;
        case 'ACCORDION':
          $scope.models.elementCopy.multiple = true;
          if (groupContainsIllegalField($scope.models.elementCopy)) {
            $scope.fieldGroupContainsIllegalFields = true;
          }
          break;
      }
    };

    const filterIBANRules = (rules) => {
      $scope.models.elementCopy.validationRules = rules.filter((rule) => {
        return !(rule['@type'] && rule['@type'] === 'IBANValidator');
      });
    };

    $scope.onFormatChange = function () {
      switch ($scope.models.format) {
        case 'MONTH_YEAR':
          $scope.models.elementCopy.additionalConfig = {
            '@type': 'AdditionalMonthYearFormatConfig'
          };
          if ($scope.models.elementCopy.validationRules) {
            $scope.models.elementCopy.validationRules = filterIBANRules($scope.models.elementCopy.validationRules);
          }
          break;
        case 'IBAN':
          if (!$scope.models.elementCopy.validationRules) {
            $scope.models.elementCopy.validationRules = [];
          }
          $scope.models.elementCopy.validationRules.push({
            '@type': 'IBANValidator'
          });
          delete $scope.models.elementCopy.additionalConfig;
          break;
        case '':
          delete $scope.models.elementCopy.additionalConfig;
          if ($scope.models.elementCopy.validationRules) {
            $scope.models.elementCopy.validationRules = filterIBANRules($scope.models.elementCopy.validationRules);
          }
          break;
      }
    };

    $scope.isAnbindungSubstanziellOrHoch = () => {
      if ($scope.models.elementCopy.$$binding.inbound) {
        return (
          $scope.models.elementCopy.$$binding.inbound.type === 'vn_substanziell' ||
          $scope.models.elementCopy.$$binding.inbound.type === 'vn_hoch'
        );
      }
      return false;
    };

    $scope.onIncomingBoundingChange = () => {
      if ($scope.isAnbindungSubstanziellOrHoch()) {
        $scope.models.elementCopy.disabled = true;
      }
      if ($scope.models.elementCopy.$$binding.inbound) {
        $scope.models.elementCopy.$$binding.inbound.variable = null;
      }
    };

    $scope.checkLayout = function () {
      if (
        $scope.models.elementCopy.layout !== undefined &&
        ($scope.models.elementCopy.layout === 'TABS' || $scope.models.elementCopy.layout === 'ACCORDION')
      ) {
        $scope.hasLayoutError =
          $scope.models.elementCopy.instanceTitleTemplate === undefined ||
          $scope.models.elementCopy.instanceTitleTemplate.trim().length === 0;
        return !$scope.hasLayoutError;
      }
      return true;
    };

    $scope.checkMaxInstanceCount = function () {
      if ($scope.models.elementCopy.fixedFieldGroupInstanceMax) {
        return $scope.models.elementCopy.maxInstanceCount;
      }
      return true;
    };

    const getLayoutFormFieldAdditionalConfigType = (type) => {
      switch (type) {
        case 'CHECKBOX':
          return 'AdditionalCheckboxConfig';
        case 'RADIO_BUTTONS':
          return 'AdditionalRadioButtonConfig';
        case 'BOOLEAN':
          return 'AdditionalBooleanConfig';
      }
    };

    const getDropdownAdditionalConfigType = (type) => {
      switch (type) {
        case 'DROPDOWN_SINGLE_SELECT':
          return 'AdditionalDropdownSingleSelectConfig';
        case 'DROPDOWN_SINGLE_SELECT_AJAX':
          return 'AdditionalDropdownSingleSelectAjaxConfig';
      }
    };

    $scope.saveEdit = function () {
      if (!$scope.isExternalBindingComplete()) {
        alert('Anbindung ist unvollständig!');
        return false;
      }

      if (!$scope.checkLayout()) {
        alert('Layout ist unvollständig! Bitte geben Sie eine Vorlage für den Instanztitel an.');
        return false;
      }

      if (!$scope.checkMaxInstanceCount()) {
        alert('Es wurde keine Maximalanzahl an Instanzen definiert. Erlaubter Bereich 1-99.');
        return false;
      }

      if ($scope.models.elementCopy.multiple && $scope.fieldGroupContainsIllegalFields) {
        alert(
          'Diese Feldgruppe enthält Felder, die nicht in einer mehrfach ausfüllbaren Feldgruppe enthalten sein dürfen.'
        );
      }

      if ($scope.models.elementCopy.type === 'HINTBOX' && !$scope.models.elementCopy.additionalConfig.status) {
        alert('Bitte wählen Sie einen Status aus.');
        return false;
      }

      if ($scope.models.elementCopy.type === 'HINTBOX' && !$scope.models.elementCopy.label) {
        alert('Bitte geben Sie eine Überschrift an.');
        return false;
      }

      if ($scope.models.elementCopy.type === 'TEXT') {
        $scope.models.elementCopy.label = window.tinymce.activeEditor.getContent();
      }

      if (
        $scope.models.elementCopy.required &&
        $scope.models.elementCopy.requiredExpression !== undefined &&
        $scope.models.elementCopy.requiredExpression.length > 1
      ) {
        alert(
          'Bitte nutzen Sie entweder die Checkbox "Pflichtfeld" (Feld ist ein Pflichtfeld), oder das Eingabefeld "Pflichtfeld Platzhalter", um das Feld abhängig von einer Prozessinstanzvariablen zum Pflichtfeld zu machen.'
        );
        return false;
      }

      if (!valuesExpressionMatchesPattern($scope.models.elementCopy.requiredExpression)) {
        return false;
      }

      if (
        $scope.models.elementCopy.type === 'FILE' &&
        $scope.models.elementCopy.additionalConfig &&
        !$scope.models.elementCopy['@type']
      ) {
        $scope.models.elementCopy.additionalConfig['@type'] = 'AdditionalFileConfig';
      }

      // KFZ KENNZEICHEN
      if ($scope.models.elementCopy.type === 'KFZ_KENNZEICHEN') {
        // Kennzeichentyp
        $scope.models.elementCopy.additionalConfig.kennzeichenType = $scope.models.kennzeichenType;
        // Sonderkennzeichen
        if (
          $scope.models.elementCopy.additionalConfig['@type'] === 'AdditionalKfzUeberfuehrungsKennzeichenConfig' ||
          $scope.models.elementCopy.additionalConfig['@type'] === 'AdditionalKfzKurzzeitKennzeichenConfig' ||
          $scope.models.elementCopy.additionalConfig['@type'] === 'AdditionalKfzRotesKennzeichenConfig'
        ) {
          delete $scope.models.elementCopy.additionalConfig.unterscheidungszeichen;
          delete $scope.models.elementCopy.additionalConfig.electric;
          delete $scope.models.elementCopy.additionalConfig.electricExpression;
          delete $scope.models.elementCopy.additionalConfig.historic;
          delete $scope.models.elementCopy.additionalConfig.historicExpression;
          delete $scope.models.elementCopy.additionalConfig.saisonStart;
          delete $scope.models.elementCopy.additionalConfig.saisonEnd;
          delete $scope.models.elementCopy.additionalConfig.erkennungsnummer2Ausblenden;
          delete $scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression;
          delete $scope.models.elementCopy.additionalConfig.kennzeichenType;
          delete $scope.models.electric;
          delete $scope.models.historic;
          delete $scope.models.erkennungsnummer2Ausblenden;
        }
        // elektrisch
        if ($scope.models.electric === 'on') {
          $scope.models.elementCopy.additionalConfig.electric = true;
          delete $scope.models.elementCopy.additionalConfig.electricExpression;
        } else if ($scope.models.electric === 'off') {
          delete $scope.models.elementCopy.additionalConfig.electric;
          delete $scope.models.elementCopy.additionalConfig.electricExpression;
        } else if ($scope.models.electric === 'showExpression') {
          if (!$scope.models.elementCopy.additionalConfig.electricExpression) {
            alert('Bitte geben Sie einen Platzhalter für die Eigenschaft "Elektrisch" ein.');
            return false;
          }
          if (
            $scope.models.elementCopy.additionalConfig.electricExpression &&
            !isValidExpression($scope.models.elementCopy.additionalConfig.electricExpression)
          ) {
            alert(
              'Bitte geben Sie einen gültigen Platzhalter für "Elektrisch" ein. Platzhalter müssen mit jeweils 2 geschweiften Klammern beginnen und enden.'
            );
            return false;
          }
          delete $scope.models.elementCopy.additionalConfig.electric;
        }
        // historisch
        if ($scope.models.historic === 'on') {
          $scope.models.elementCopy.additionalConfig.historic = true;
          delete $scope.models.elementCopy.additionalConfig.historicExpression;
        } else if ($scope.models.historic === 'off') {
          delete $scope.models.elementCopy.additionalConfig.historic;
          delete $scope.models.elementCopy.additionalConfig.historicExpression;
        } else if ($scope.models.historic === 'showExpression') {
          if (!$scope.models.elementCopy.additionalConfig.historicExpression) {
            alert('Bitte geben Sie einen Platzhalter für die Eigenschaft "Historisch" ein.');
            return false;
          }
          if (
            $scope.models.elementCopy.additionalConfig.historicExpression &&
            !isValidExpression($scope.models.elementCopy.additionalConfig.historicExpression)
          ) {
            alert(
              'Bitte geben Sie einen gültigen Platzhalter für "Historisch" ein. Platzhalter müssen mit jeweils 2 geschweiften Klammern beginnen und enden.'
            );
            return false;
          }
          delete $scope.models.elementCopy.additionalConfig.historic;
        }
        // erkennungsnummer2 ausblenden
        if ($scope.models.erkennungsnummer2Ausblenden === 'on') {
          $scope.models.elementCopy.additionalConfig.erkennungsnummer2Ausblenden = true;
          delete $scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression;
        } else if ($scope.models.erkennungsnummer2Ausblenden === 'off') {
          delete $scope.models.elementCopy.additionalConfig.erkennungsnummer2Ausblenden;
          delete $scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression;
        } else if ($scope.models.erkennungsnummer2Ausblenden === 'showExpression') {
          if (!$scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression) {
            alert('Bitte geben Sie einen Platzhalter für die Eigenschaft "Erkennungsnummer2 ausblenden" ein.');
            return false;
          }
          if (
            $scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression &&
            !isValidExpression($scope.models.elementCopy.additionalConfig.erkennungsnummer2AusblendenExpression)
          ) {
            alert(
              'Bitte geben Sie einen gültigen Platzhalter für "Erkennungsnummer2 ausblenden" ein. Platzhalter müssen mit jeweils 2 geschweiften Klammern beginnen und enden.'
            );
            return false;
          }
          delete $scope.models.elementCopy.additionalConfig.erkennungsnummer2Ausblenden;
        }
        // Saison
        if (
          ($scope.models.elementCopy.additionalConfig.saisonStart &&
            !$scope.models.elementCopy.additionalConfig.saisonEnd) ||
          (!$scope.models.elementCopy.additionalConfig.saisonStart &&
            $scope.models.elementCopy.additionalConfig.saisonEnd)
        ) {
          alert('Bitte füllen Sie für ein Saisonkennzeichen sowohl Saison Start als auch Saison Ende aus.');
          return false;
        }
        if (
          !$scope.models.elementCopy.additionalConfig.saisonStart &&
          !$scope.models.elementCopy.additionalConfig.saisonEnd
        ) {
          delete $scope.models.elementCopy.additionalConfig.saisonStart;
          delete $scope.models.elementCopy.additionalConfig.saisonEnd;
        }

        // Unterscheidungszeichen
        if (
          $scope.models.elementCopy.additionalConfig.unterscheidungszeichen &&
          !unterscheidungszeichenIsValid($scope.models.elementCopy.additionalConfig.unterscheidungszeichen)
        ) {
          alert(
            'Bitte geben Sie ein gültiges Unterscheidungszeichen oder einen gültigen Platzhalter ein. Platzhalter müssen mit jeweils 2 geschweiften Klammern beginnen und enden.'
          );
          return false;
        }
        if (!$scope.models.elementCopy.additionalConfig.unterscheidungszeichen) {
          delete $scope.models.elementCopy.additionalConfig.unterscheidungszeichen;
        }
      }

      var binding = $scope.models.elementCopy.$$binding;
      var hasSourceBinding = false,
        hasTargetBinding = false,
        hasListBinding = false;

      if (binding) {
        if (binding.inbound) {
          if (binding.inbound.type === 'process') {
            $scope.models.elementCopy.source = {
              service: 'prozess',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'servicekonto') {
            $scope.models.elementCopy.source = {
              service: 'servicekonto',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'npa') {
            $scope.models.elementCopy.source = {
              service: 'npa',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'vn_basis') {
            $scope.models.elementCopy.source = {
              service: 'vn_basis',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'vn_substanziell') {
            $scope.models.elementCopy.source = {
              service: 'vn_substanziell',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'vn_hoch') {
            $scope.models.elementCopy.source = {
              service: 'vn_hoch',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'browser_autocomplete') {
            $scope.models.elementCopy.source = {
              service: 'browser_autocomplete',
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          } else if (binding.inbound.type === 'service') {
            $scope.models.elementCopy.source = {
              service: binding.inbound.url,
              variableName: binding.inbound.variable
            };
            hasSourceBinding = true;
          }
        }
        if (binding.outbound) {
          if (binding.outbound.type === 'process') {
            $scope.models.elementCopy.target = {
              service: 'prozess',
              variableName: binding.outbound.variable
            };
            hasTargetBinding = true;
          } else if (binding.outbound.type === 'service') {
            $scope.models.elementCopy.target = {
              service: binding.outbound.url,
              variableName: binding.outbound.variable
            };
            hasTargetBinding = true;
          }
        }
      }

      if ($scope.models.selectedListSource) {
        if ($scope.models.selectedListSource === 'process') {
          $scope.models.elementCopy.possibleValuesSource = {
            service: 'prozess',
            variableName: $scope.models.selectedListVariable
          };
          hasListBinding = true;
        }
        if ($scope.models.selectedListSource === 'service') {
          $scope.models.elementCopy.possibleValuesSource = {
            service: $scope.models.selectedListUrl,
            variableName: $scope.models.selectedListVariable
          };
          hasListBinding = true;
        }
      }

      if (!hasSourceBinding) {
        delete $scope.models.elementCopy.source;
      }

      if (!hasTargetBinding) {
        delete $scope.models.elementCopy.target;
      }

      if (!hasListBinding) {
        delete $scope.models.elementCopy.possibleValuesSource;
      }

      if (
        $scope.models.elementCopy.externalDataSourceProperties &&
        $scope.models.elementCopy.externalDataSourceProperties.scope !== 'DEFINED'
      ) {
        $scope.models.elementCopy.externalDataSourceProperties.fieldIds = [];
      }

      if ($scope.models.elementCopy.externalValue) {
        if (
          !$scope.models.elementCopy.externalValue.proxyHost ||
          $scope.models.elementCopy.externalValue.proxyHost.trim().length === 0 ||
          $scope.models.elementCopy.externalValue.proxyPort === undefined ||
          $scope.models.elementCopy.externalValue.proxyPort === null ||
          $scope.models.elementCopy.externalValue.proxyPort.toString().trim().length === 0
        ) {
          delete $scope.models.elementCopy.externalValue.proxyHost;
          delete $scope.models.elementCopy.externalValue.proxyPort;
        }
      }

      if ($scope.models.elementCopy.externalDataSourceProperties) {
        if (
          !$scope.models.elementCopy.externalDataSourceProperties.proxyHost ||
          $scope.models.elementCopy.externalDataSourceProperties.proxyHost.trim().length === 0 ||
          $scope.models.elementCopy.externalDataSourceProperties.proxyPort === undefined ||
          $scope.models.elementCopy.externalDataSourceProperties.proxyPort === null ||
          $scope.models.elementCopy.externalDataSourceProperties.proxyPort.toString().trim().length === 0
        ) {
          delete $scope.models.elementCopy.externalDataSourceProperties.proxyHost;
          delete $scope.models.elementCopy.externalDataSourceProperties.proxyPort;
        }
      }

      if (!$scope.models.displayHelpDialog) {
        delete $scope.models.elementCopy.helpDialog;
      }

      if (
        $scope.models.elementCopy.requiredExpression !== undefined &&
        $scope.models.elementCopy.requiredExpression.length === 0
      ) {
        delete $scope.models.elementCopy.requiredExpression;
      }
      if (
        !$scope.models.elementCopy.requiredValidationFailedMessage ||
        $scope.models.elementCopy.requiredValidationFailedMessage.trim().length === 0 ||
        (!$scope.models.elementCopy.required && !$scope.models.elementCopy.requiredExpression)
      ) {
        delete $scope.models.elementCopy.requiredValidationFailedMessage;
      }
      if (!$scope.models.elementCopy.typeValidationFailedMessage) {
        delete $scope.models.elementCopy.typeValidationFailedMessage;
      }
      if (
        !$scope.models.elementCopy.thousandsSeparatorValidationFailedMessage ||
        $scope.models.elementCopy.thousandsSeparatorValidationFailedMessage.trim().length === 0
      ) {
        delete $scope.models.elementCopy.thousandsSeparatorValidationFailedMessage;
      }
      if (
        !$scope.models.elementCopy.digitsAfterDecimalPointValidationFailedMessage ||
        $scope.models.elementCopy.digitsAfterDecimalPointValidationFailedMessage.trim().length === 0
      ) {
        delete $scope.models.elementCopy.digitsAfterDecimalPointValidationFailedMessage;
      }
      if (!$scope.models.elementCopy.addRowButton) {
        delete $scope.models.elementCopy.addRowButton;
      }
      if (!$scope.models.elementCopy.deleteRowButton) {
        delete $scope.models.elementCopy.deleteRowButton;
      }

      if (
        $scope.models.elementCopy.type === 'DROPDOWN_SINGLE_SELECT' ||
        $scope.models.elementCopy.type === 'DROPDOWN_SINGLE_SELECT_AJAX'
      ) {
        if ($scope.models.filterable) {
          if ($scope.models.engineVersion === '2') {
            $scope.models.elementCopy.additionalConfig = {
              ['@type']: getDropdownAdditionalConfigType($scope.models.elementCopy.type),
              filterable: true
            };
          } else {
            $scope.models.elementCopy.filterable = true;
          }
        } else {
          delete $scope.models.elementCopy.filterable;
          delete $scope.models.elementCopy.additionalConfig;
        }
      }

      if ($scope.models.elementCopy.type === 'DATE') {
        if ($scope.models.pickerDisabled) {
          if ($scope.models.engineVersion === '2') {
            $scope.models.elementCopy.additionalConfig = {
              ['@type']: 'AdditionalDateConfig',
              pickerDisabled: true
            };
          } else {
            $scope.models.elementCopy.pickerDisabled = true;
          }
        } else {
          delete $scope.models.elementCopy.pickerDisabled;
          delete $scope.models.elementCopy.additionalConfig;
        }
      }

      if (layoutFormFields.includes($scope.models.elementCopy.type)) {
        if ($scope.models.engineVersion === '2') {
          $scope.models.elementCopy.additionalConfig = {
            ['@type']: getLayoutFormFieldAdditionalConfigType($scope.models.elementCopy.type),
            layout: $scope.models.elementCopy.layout
          };

          delete $scope.models.elementCopy.layout;
        }
      }

      if ($scope.models.elementCopy.layout === 'SINGLE' || $scope.models.elementCopy.layout === 'MULTIPLE') {
        delete $scope.models.elementCopy.layout;
      }
      if ($scope.models.elementCopy.fixedFieldGroupInstanceMax) {
        delete $scope.models.elementCopy.fixedFieldGroupInstanceMax;
      }
      if (!$scope.models.elementCopy.addRowButtonInfoText) {
        delete $scope.models.elementCopy.addRowButtonInfoText;
      }
      if (!$scope.models.elementCopy.deleteRowButtonInfoText) {
        delete $scope.models.elementCopy.deleteRowButtonInfoText;
      }
      if ($scope.models.elementCopy.additionalConfig && !$scope.models.elementCopy.additionalConfig.caption) {
        delete $scope.models.elementCopy.additionalConfig.caption;
      }
      if ($scope.models.elementCopy.additionalConfig && $scope.models.elementCopy.additionalConfig.compress) {
        $scope.models.elementCopy.additionalConfig['@type'] = 'AdditionalFileConfig';
      }
      if ($scope.models.elementCopy.required === false) {
        delete $scope.models.elementCopy.required;
      }
      if (!$scope.models.elementCopy.fimId) {
        delete $scope.models.elementCopy.fimId;
      }

      if ($scope.models.elementCopy.validationRules) {
        $scope.models.elementCopy.validationRules.forEach((rule) => {
          if (rule['@type'] === 'MaxDateValueValidator' && rule.maxValue && rule.maxValueExpression) {
            delete rule.maxValue;
          }
          if (rule['@type'] === 'MinDateValueValidator' && rule.minValue && rule.minValueExpression) {
            delete rule.minValue;
          }
        });
      }

      // proxy settings

      const setInternetProxy = (target) => {
        if (!target) {
          return;
        }
        delete target.proxyHost;
        delete target.proxyPort;
        delete target.proxyPortExpression;
        target.proxyType = 'INTERNET';
      };

      const setKVNProxy = (target) => {
        if (!target) {
          return;
        }
        delete target.proxyHost;
        delete target.proxyPort;
        delete target.proxyPortExpression;
        target.proxyType = 'KVN';
      };

      const setManualProxy = (target) => {
        if (!target) {
          return;
        }
        delete target.proxyType;
      };

      const setNoProxy = (target) => {
        if (!target) {
          return;
        }
        delete target.proxyHost;
        delete target.proxyPort;
        delete target.proxyPortExpression;
        delete target.proxyType;
      };

      const checkProxyConfig = (base) => {
        switch (base.proxyType) {
          case 'INTERNET':
            setInternetProxy(base);
            break;

          case 'KVN':
            setKVNProxy(base);
            break;

          case 'MANUAL':
            setManualProxy(base);
            break;

          default:
            setNoProxy(base);
            break;
        }
      };

      if ($scope.models.elementCopy.externalValue) {
        checkProxyConfig($scope.models.elementCopy.externalValue);
      }

      if ($scope.models.elementCopy.externalDataSourceProperties) {
        checkProxyConfig($scope.models.elementCopy.externalDataSourceProperties);
      }

      if ($scope.models.elementCopy.validationRules) {
        $scope.models.elementCopy.validationRules.forEach((rule) => {
          if (rule['@type'] && rule['@type'] === 'ExternalValidator') {
            checkProxyConfig(rule.settings);
          }
        });
      }

      $scope.date2Seconds();
      angular.copy($scope.models.elementCopy, $scope.models.element);
      $scope.seconds2Date();
      $scope.closeEdit();
    };

    $scope.cancelEdit = function () {
      $scope.date2Seconds();
      var elementCopyCopy = angular.copy($scope.models.elementCopy);
      if (elementCopyCopy.layout === 'SINGLE' || elementCopyCopy.layout === 'MULTIPLE') {
        delete elementCopyCopy.layout;
      }
      if (elementCopyCopy.fixedFieldGroupInstanceMax) {
        delete elementCopyCopy.fixedFieldGroupInstanceMax;
      }
      var hasChanges = !angular.equals(elementCopyCopy, $scope.models.element);
      $scope.seconds2Date();
      if (hasChanges && !confirm('Änderungen verwerfen?')) {
        return;
      }
      $scope.closeEdit();
    };

    $scope.closeEdit = function () {
      $timeout(function () {
        $scope.models.elementCopy = undefined;
        // TODO: Solve this with Angular
        $('body').removeClass('fd-s-unscrollable');
        $scope.$emit('edit-close');
      }, 250);
      $scope.models.element = undefined;
    };

    $scope.isExternalBindingComplete = function () {
      var elem = $scope.models.elementCopy,
        inStatus = true,
        outStatus = true;

      if (!elem.$$binding) {
        return true;
      }

      if (elem.$$binding.inbound && elem.$$binding.inbound.type !== '') {
        if (elem.$$binding.inbound.type === 'service') {
          if (!elem.$$binding.inbound.variable || !elem.$$binding.inbound.url) {
            inStatus = false;
          }
        } else {
          if (!elem.$$binding.inbound.variable) {
            inStatus = false;
          }
        }
      }

      if (elem.$$binding.outbound && elem.$$binding.outbound.type !== '') {
        if (elem.$$binding.outbound.type === 'service') {
          if (!elem.$$binding.outbound.variable || !elem.$$binding.outbound.url) {
            outStatus = false;
          }
        } else if (elem.$$binding.outbound.type === 'process') {
          if (!elem.$$binding.outbound.variable) {
            outStatus = false;
          }
        }
      }

      return inStatus && outStatus;
    };

    $scope.seconds2Date = function () {
      // convert timestamp (milliseconds) to date object
      if ($scope.models.elementCopy.type === 'DATE') {
        if (typeof $scope.models.elementCopy.value === 'number') {
          $scope.models.elementCopy.value = new Date($scope.models.elementCopy.value);
        }
      }

      if ($scope.models.elementCopy.type === 'TIME') {
        if (typeof $scope.models.elementCopy.value === 'number') {
          var d = new Date($scope.models.elementCopy.value);
          d.setFullYear(1970, 0, 1);
          $scope.models.elementCopy.value = d;
        }
      }
    };

    $scope.date2Seconds = function () {
      // convert date object to timestamp (milliseconds)
      if (typeof $scope.models.elementCopy.value === 'number' || !$scope.models.elementCopy.value) {
        return;
      }

      if ($scope.models.elementCopy.type === 'TIME') {
        $scope.models.elementCopy.value = $scope.models.elementCopy.value.getTime();
      }

      if ($scope.models.elementCopy.type === 'DATE') {
        $scope.models.elementCopy.value = $scope.models.elementCopy.value.getTime();
      }
    };

    $scope.tabPaneResizeGuardian = function () {
      var tabPanes = $('.fd-l-dialog .tab-pane');
      if (!tabPanes.length) {
        $timeout($scope.tabPaneResizeGuardian, 50);
        return;
      }
      tabPanes.each(function () {
        this.style.height = window.innerHeight - 210 + 'px';
      });
    };

    $scope.addPlaceholderToInstanceTitle = function () {
      var placeholder = '${' + ($scope.models.placeholder || 'instanceIndex') + '}';
      var element = document.getElementById('fieldInstanceTitleTemplate');
      var template = $scope.models.elementCopy.instanceTitleTemplate || '';
      if (element.selectionStart || element.selectionStart === 0) {
        var startPos = element.selectionStart;
        var endPos = element.selectionEnd;
        template = template.substring(0, startPos) + placeholder + template.substring(endPos, element.value.length);
      } else {
        template = template + placeholder;
      }
      $scope.models.elementCopy.instanceTitleTemplate = template;
      element.focus();
      $timeout(function () {
        if (startPos >= 0) {
          element.selectionStart = startPos + placeholder.length;
          element.selectionEnd = startPos + placeholder.length;
        }
      });
    };

    $scope.onKennzeichenTypeChange = function () {
      if ($scope.models.kennzeichenType === 'MOTORCYCLE') {
        $scope.models.elementCopy.additionalConfig['@type'] = 'AdditionalKfzKennzeichenConfig';
      }
    };

    $scope.init();
  }
]);
